var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelordericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.9624 9.30078L14.9999 15.6883L25.9624 9.33824",
    stroke: "#393945",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9998 27.0133V15.6758",
    stroke: "#393945",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0124 11.4625V18.5375C27.0124 18.6 27.0124 18.65 26.9999 18.7125C26.1249 17.95 24.9999 17.5 23.7499 17.5C22.5749 17.5 21.4874 17.9125 20.6249 18.6C19.4749 19.5125 18.7499 20.925 18.7499 22.5C18.7499 23.4375 19.0124 24.325 19.4749 25.075C19.5874 25.275 19.7249 25.4625 19.8749 25.6375L17.5874 26.9C16.1624 27.7 13.8374 27.7 12.4124 26.9L5.7374 23.2C4.2249 22.3625 2.98743 20.2625 2.98743 18.5375V11.4625C2.98743 9.7375 4.2249 7.63753 5.7374 6.80003L12.4124 3.1C13.8374 2.3 16.1624 2.3 17.5874 3.1L24.2624 6.80003C25.7749 7.63753 27.0124 9.7375 27.0124 11.4625Z",
    stroke: "#393945",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.75 22.5C28.75 23.4375 28.4875 24.325 28.025 25.075C27.7625 25.525 27.425 25.925 27.0375 26.25C26.1625 27.0375 25.0125 27.5 23.75 27.5C21.925 27.5 20.3375 26.525 19.475 25.075C19.0125 24.325 18.75 23.4375 18.75 22.5C18.75 20.925 19.475 19.5125 20.625 18.6C21.4875 17.9125 22.575 17.5 23.75 17.5C26.5125 17.5 28.75 19.7375 28.75 22.5Z",
    stroke: "#393945",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0875 23.7996L22.4375 21.1621",
    stroke: "#393945",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0625 21.1992L22.4125 23.8367",
    stroke: "#393945",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelordericon);
export default __webpack_public_path__ + "static/media/cancelordericon.09181bf9.svg";
export { ForwardRef as ReactComponent };